<template>
	<form :class="classList" :action="endpoint" ref="dropzone">
		<slot></slot>
	</form>
</template>

<script>
	import Dropzone from 'dropzone';
	Dropzone.autoDiscover = false;

	/**
	 * Checkout the env_dz.js file to see what each option means
	 */

	export default {
		props: {
			endpoint: {
				type: String,
				required: true
			},
			classes: {
				type: Array,
				default: () => []
			},
			
			// Plugin options
			clickable: {
				type: Boolean,
				default: true
			},
			removeFileOnComplete: {
				type: Boolean,
				default: true
			},
			removeFileOnCompleteTimeout: {
				type: Number,
				default: 3000
			},
			generalizeErrorMessage: {
				type: Boolean,
				default: true
			},
			showErrors: {
				type: Boolean,
				default: true
			},
			paramName: {
				type: String,
				default: 'file'
			},
			maxFilesize: {
				type: Number,
				default: 4
			},
			maxFiles: {
				type: Number,
				default: 1
			},
			autoProcessQueue: {
				type: Boolean,
				default: true
			},
			addRemoveLinks: {
				type: Boolean,
				default: true
			},
			method: {
				type: String,
				default: 'post'
			},
			uploadMultiple: {
				type: Boolean,
				default: false
			},
			headers: {
				type: Object,
				default: () => {}
			},
			previewsContainer: {
				default: null
			},
			hiddenInputContainer: {
				type: String,
				default: 'body'
			},
			maxThumbnailFilesize: {
				type: Number,
				default: 4
			},
			acceptedFiles: {
				type: String,
				default: ''
			},
			previewTemplate: {
				type: String,
				default: ''
			},
			createImageThumbnails: {
				type: Boolean,
				default: true
			},
			parallelUploads: {
				type: Number,
				default: 2
			}
		},
		mounted() {
			let vm = this;
			$(this.$refs.dropzone).env_dz({
				remove_file_on_complete: vm.removeFileOnComplete,
				remove_file_on_complete_timeout: vm.removeFileOnCompleteTimeout,
				generalize_error_message: vm.generalizeErrorMessage,
				show_errors: vm.showErrors,
				
				// Dropzone variables
				paramName: vm.paramName,
				maxFilesize: vm.maxFilesize,
				maxFiles: vm.maxFiles,
				autoProcessQueue: vm.autoProcessQueue,
				addRemoveLinks: vm.addRemoveLinks,
				method: vm.method,
				uploadMultiple: vm.uploadMultiple,
				headers: vm.headers,
				clickable: vm.clickable,
				previewsContainer: vm.previewsContainer,
				hiddenInputContainer: vm.hiddenInputContainer,
				maxThumbnailFilesize: vm.maxThumbnailFilesize,
				acceptedFiles: vm.acceptedFiles,
				createImageThumbnails: vm.createImageThumbnails,
				parallelUploads: vm.parallelUploads,
				
				/**
				 * Event hooks
				 */
				addedfile(file, dz, $el) {
					vm.$emit('addedfile', file, dz, $el);
				},
				canceled(file, dz, $el) {
					vm.$emit('canceled', file, dz, $el);	
				},
				canceledmultiple(files, dz, $el) {
					vm.$emit('canceledmultiple', files, dz, $el);
				},
				complete(file, dz, $el) {
					vm.$emit('complete', file, dz, $el);	
				},
				completemultiple(files, dz, $el) {
					vm.$emit('completemultiple', files, dz, $el);
				},
				error(file, dz, $el) {
					vm.$emit('error', file, dz, $el);
				},
				removedfile(file, dz, $el) {
					vm.$emit('removedfile', file, dz, $el);
				},
				processing(file, dz, $el) {
					vm.$emit('processing', file, dz, $el);
				},
				processingmultiple(files, dz, $el) {
					vm.$emit('processingmultiple', files, dz, $el);
				},
				queuecomplete(dz, $el) {
					vm.$emit('queuecomplete', dz, $el);	
				},
				sending(file, xhr, formData, dz, $el) {
					vm.$emit('sending', file, xhr, formData, dz, $el);
				},
				success(file, response, dz, $el) {
					vm.$emit('success', file, response, dz, $el);
				},
				successmultiple(files, response, dz, $el) {
					vm.$emit('successmultiple', files, response, dz, $el);
				},
				thumbnail(file, dataUrl, dz, $el) {
					vm.$emit('thumbnail', file, dataUrl, dz, $el);
				},
				maxfilesreached(files) {
					vm.$emit('maxfilesreached', files);
				}
			});
		},
		destroyed() {
			$(this.$refs.el).env_dz('destroy');
		},
		computed: {
			classList() {
				let classes = this.classes;
				classes.push('dropzone');
				return classes;
			}
		},
		methods: {
			/**
			 * Trigger the click event.
			 */
			triggerClick() {
				$(this.$refs.dropzone).click();
			}
		}
	}
</script>